export default __webpack_public_path__ + "static/media/screen1.c67eb0b4.png";